// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"196":"e0f47d4b","583":"d0c4f5e2","983":"7b2c67d8"}[chunkId] + ".chunk.js");